import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import PageWrapper from "components/page/PageWrapper";
import bg from 'assets/images/banner/banner01.jpg';
import QEditor from "components/editor/QEditor";

export default function Partners(){
  const {t} = useTranslation();
  const params = useParams();
  const menuName= t('menu.sub-editor');
  const path=[
    {url:'/projects', name:t('menu.main-projects')},
    {url:'/projects', name:t('menu.sub-references')},
    {url:'/projects/editor', name:menuName}];
  const title = t('references.banner.title')
  const comment = t('references.banner.comment')

  const type = 'projects';

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center">
        <div className="flex flex-col lg:w-[1200px]">
          <div className="mb-20">
            <QEditor postId={params.id} type={type}/>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
